import { useEffect, useState } from 'react';
import { useStore } from '../../store/useStore';

const KONAMI_CODE = [
  'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
  'KeyB', 'KeyA'
];

export default function KonamiEasterEgg() {
  const [sequence, setSequence] = useState<string[]>([]);
  const { konami, setKonami, incrementSecrets } = useStore();
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const newSequence = [...sequence, e.code].slice(-10);
      setSequence(newSequence);

      if (newSequence.join(',') === KONAMI_CODE.join(',')) {
        setKonami(!konami);
        incrementSecrets();
        setShowMessage(true);
        setTimeout(() => setShowMessage(false), 3000);
        setSequence([]);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [sequence, konami, setKonami, incrementSecrets]);

  if (!showMessage) return null;

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-50 animate-bounce-subtle">
      <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 text-white px-6 py-3 rounded-full shadow-lg">
        <span className="text-lg font-bold">
          {konami ? '🎉 Party Mode Activated!' : '😢 Party Mode Deactivated'}
        </span>
      </div>
    </div>
  );
}
